export default __webpack_public_path__ + "static/media/animaker3.d97e8667.jpg";